import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usuarios-roadshow-tabla',
  templateUrl: './usuarios-roadshow-tabla.component.html',
  styleUrls: ['./usuarios-roadshow-tabla.component.scss']
})
export class UsuariosRoadshowTablaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
